import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { products } from '../../mocks/products';
import { useCart } from '../../contexts/CartContext';

export default function CatalogoPage() {
  const { addToCart } = useCart();
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [notification, setNotification] = useState('');

  const categories = ['Todos', 'Camperas'];

  const filteredProducts = selectedCategory === 'Todos'
    ? products
    : products.filter(p => p.category === selectedCategory);

  const handleAddToCart = (product: typeof products[0]) => {
    addToCart(product);
    setNotification(`${product.name} agregado al carrito`);
    setTimeout(() => setNotification(''), 3000);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-24 pb-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h1 className="text-3xl md:text-6xl font-light mb-4">Catálogo</h1>
            <p className="text-gray-600 text-base md:text-lg">Explora nuestra colección completa</p>
          </div>

          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12 md:mb-16">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 md:px-6 py-2 rounded-full text-xs md:text-sm transition-all whitespace-nowrap ${
                  selectedCategory === category
                    ? 'bg-[#F2C4CE] text-gray-900'
                    : 'bg-gray-100 text-gray-700 hover:bg-[#f7dde3]'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <div
                key={product.id}
                className="group bg-white rounded-2xl md:rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
              >
                <div className="aspect-[3/4] overflow-hidden bg-gray-50">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-3 md:p-6">
                  <div className="text-xs text-gray-500 mb-1 md:mb-2">{product.category}</div>
                  <h3 className="font-medium text-gray-900 mb-1 md:mb-2 text-sm md:text-lg line-clamp-1">{product.name}</h3>
                  <p className="text-xs md:text-sm text-gray-600 mb-3 md:mb-4 line-clamp-2 hidden md:block">{product.description}</p>
                  <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
                    <span className="text-lg md:text-2xl font-light text-gray-900">${product.price}</span>
                    <button
                      onClick={() => handleAddToCart(product)}
                      className="w-full md:w-auto px-4 md:px-5 py-1.5 md:py-2 bg-[#F2C4CE] text-gray-900 rounded-full hover:bg-[#e8adb8] transition-colors text-xs md:text-sm whitespace-nowrap"
                    >
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {notification && (
        <div className="fixed bottom-4 md:bottom-8 right-4 md:right-8 left-4 md:left-auto bg-gray-900 text-white px-4 md:px-6 py-3 md:py-4 rounded-2xl shadow-lg z-50 animate-fade-in">
          <div className="flex items-center gap-3">
            <i className="ri-check-line text-lg md:text-xl"></i>
            <span className="text-sm md:text-base">{notification}</span>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}